<template>
  <div>
    <base-modal @close="$emit('close')" hide-footer :title="$t('common.search')">
      <div class="editor-form">
          <span class="span-title"> {{ $t('map.search_address') }} </span>
          <input
              id="address-search"
              v-model="searchText"
              class="form-control"
              type="text"
          />
        <hr>
        <div class="row">
          <div class="col">
            <span class="span-title"> {{ $t('map.road_number') }} </span>
          </div>
          <div class="col">
            <span class="span-title"> {{ $t('map.road_section') }} </span>
          </div>
          <div class="col">
            <span class="span-title"> {{ $t('map.distance') }} </span>
          </div>
        </div>
        <div class="row">
            <div class="col">
                <input
                    id="road-number"
                    v-model="roadNumber"
                    class="form-control form-control-sm pb-2"
                    type="number"
                    min="0"
                    step="1"
                />
            </div>
            <div class="col">
                <input
                    id="road-section"
                    v-model="sectionNumber"
                    class="form-control form-control-sm pb-2"
                    type="number"
                    min="0"
                    step="1"
                />
            </div>
            <div class="col">
                <input
                    id="distance"
                    v-model="distance"
                    class="form-control form-control-sm pb-2"
                    type="number"
                    min="0"
                    step="1"
                />
            </div>
        </div>
        <hr>
        <div class="button-container">
          <button class="btn btn-primary btn-sm form-button" :disabled="loading" @click.stop="search">
            {{ $t('common.search') }}
          </button>
        </div>
        <ul class="suggestions-list">
          <li
            v-for="item in suggestions"
            :key="item.id"
            @click="selectAddress(item)"
          >
            {{ item.text }}
          </li>
        </ul>
      </div>
      <div
        v-if="loading"
        id="loader"
        class="spinner"
      />
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '../BaseModal'
import { geoCoder } from '../mixins/GeocodingMixin'
import {restApi} from "@/components/mixins/RestApiMixin";

export default {
    name: 'AddressSearchWizard',
    components: { BaseModal },
    mixins: [geoCoder, restApi],
    props: {
        coordinates: {
            type: Object,
            default() {
                return null
            },
        },
        map: {
            type: Object,
            default: null,
        },
        getCoordinate: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            loading: false,
            searchText: '',
            roadNumber: null,
            sectionNumber: null,
            distance: null,
            suggestions: [],
        }
    },

    methods: {
        search() {
            // Street name
            if (this.searchText && this.searchText.length > 1) {
                this.searchByAddress(
                    this.searchText,
                    (data) => {
                        if (data.length === 0) return (this.suggestions = [])
                        this.suggestions = data
                    },
                    () => {}
                )
            }
            // Number - section - distance
            if (this.roadNumber && this.sectionNumber && this.distance) {
                this.loading = true
                this.restFetchParams(this.roadGeometryPointUrl, {
                        road: this.roadNumber,
                        section: this.sectionNumber,
                        distance: this.distance
                    },
                    this.handleRoadSearch)
            }
        },

        handleRoadSearch(response) {
            this.loading = false
            this.suggestions = []
            if (response && response.data) {
                response.data.forEach(result =>

                        this.suggestions.push({
                            id: -1,
                            text: this.roadNumber + ' / ' + this.sectionNumber + ', ' + this.distance + ' m',
                            lat: result.lat,
                            lon: result.lon
                        })
                )
            }
        },

        selectAddress(item) {
            this.map.zoomToPosition(item.lat, item.lon, 15)
            if(this.getCoordinate) {
                this.$emit('pointFetched', {lat: item.lat, lon: item.lon})
            } else {
                this.map.showMapMarker(item.id, this.OTHER, item.lat, item.lon, this.map.getMarkerStore().getSolidCircleIcon())
                this.$emit('close')
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/modal.css';
ul.suggestions-list {
    list-style: none;
    padding: 0;
    margin: 1rem 0 0 0;
    max-height: 400px;
    overflow: auto;

    li {
        padding: 1em 0.5em;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        Transition: background-color 0.25s ease-out;
        cursor: pointer;

        &:last-child {
            border-bottom: none;
        }
        &:only-child {
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        &:hover {
            background-color: rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
